import { Observable } from "rxjs";
import { MERCHANT_ORGANIZATION } from "constants/action-types";
import { createAuthHeader } from "models/new/helpers";
import type { TMerchantOrganization } from "models/new/merchant-organization";
import { getConfig } from "site-config";

import { ajax } from "../lib/observable";

export type TFetchOrganizationPayload = {
    merchantId: string;
};

export type TFetchOrganizationResponse = {
    organization: TMerchantOrganization;
};

export const fetchMerchantOrganizationEpic = (action$) => {
    return action$
        .ofType(MERCHANT_ORGANIZATION.FETCH.START)
        .concatMap(({ payload }: { payload: TFetchOrganizationPayload }) =>
            ajax({
                method: "GET",
                url: `${getConfig().MERCHANT_ORGANIZATION_URL}/organizations/${payload.merchantId}`,
                headers: createAuthHeader({ bypassEnvironmentCheck: true }),
            })
                .flatMap(({ response }: { response: TFetchOrganizationResponse }) => [
                    { payload: response, type: MERCHANT_ORGANIZATION.FETCH.SUCCESS },
                ])
                .catch((error) =>
                    Observable.of({ error: true, payload: error, type: MERCHANT_ORGANIZATION.FETCH.ERROR }),
                ),
        );
};
